import { render, staticRenderFns } from "./PreschoolTeachers.vue?vue&type=template&id=58e5e404"
import script from "./PreschoolTeachers.vue?vue&type=script&lang=js"
export * from "./PreschoolTeachers.vue?vue&type=script&lang=js"
import style0 from "./PreschoolTeachers.vue?vue&type=style&index=0&id=58e5e404&prod&module=true&lang=scss"
import style1 from "./PreschoolTeachers.vue?vue&type=style&index=1&id=58e5e404&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports